import { Component, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { KomunikatyModulMapowyAdapter } from 'src/app/core/adaptery/komunikaty-adapter';
import { KontaktService } from 'src/app/core/service/kontakt.service';

@Component({
  selector: 'mm-kontakt-formularz',
  templateUrl: './kontakt-formularz.component.html',
  styleUrls: ['./kontakt-formularz.component.scss']
})
export class KontaktFormularzComponent {
  @Output() poWyslaniu = new EventEmitter<any>();
  wiadomoscLiczbaZnakow = 0;
  form = new FormGroup({
    email: new FormControl('', [Validators.email, Validators.required]),
    wiadomosc: new FormControl('', Validators.required)

  });
  zaladowanePliki: File[] = [];
  czyNiepoprawnyFormat = false;

  /**
   * Konstruktor
   */
  constructor(private kontaktService: KontaktService,
    private komunikaty: KomunikatyModulMapowyAdapter,
  ) {
    this.utworzFormGroup();
  }

  /**
   * Funkcja wysyła dane z formularza do serwera
   */
  wyslij(): void {
  }


  /**
   * Funckja reaguje na wpisywany tekst i wylicza jego długość
   * @param event - natywne zdarzenie
   */
  zmianaWiadomosci(event: any): void {
    this.wiadomoscLiczbaZnakow = event.target.value.length;
  }
  addWiadomosc() {
    let email = this.form.get('email')?.value;
    let tresc = 'Portal Historyczny <br />' + this.form.get('wiadomosc')?.value
    this.kontaktService.addEmail({
      wyslaneOd: email!,
      zawartosc: tresc!,
      adresBiezacejMapy: ''
    }).subscribe(() => {
      this.komunikaty.pokazPomyslnyKomunikat('Wysłano pomyślnie.', {});
      this.poWyslaniu.emit('');
    },
      (error) => {
        this.komunikaty.pokazKomunikatBledu('Wystąpił błąd, spróbuj ponownie.', {});
      });
  }
  /**
   * Funkcja inicjalizuje formularz
   */
  utworzFormGroup(): void {
    this.form = new FormGroup({
      email: new FormControl('', [Validators.email, Validators.required]),
      wiadomosc: new FormControl('', Validators.required),
    });
  }

  /**
   * Funkcja usuwa wiodące spacje
   * @param event - natywne zdarzenie
   */
  usunWiodacaSpacje(event: KeyboardEvent): void {
    this.form.controls.email?.setValue(this.form.controls.email.value!.replace(/^\s+/g, ''));
    this.form.controls.wiadomosc?.setValue(this.form.controls.wiadomosc.value!.replace(/^\s+/g, ''));
  }


}
